$(document).ready(function() {
	/*=======================================================================================================================
	===============================================  SETTINGS  ==============================================================
	========================================================================================================================*/
	// Dulezite jsu csska - trida 'nav-up', ktera se pridava celemu menu (k navbaru) + padding body a transition 'navbar'
	var lastScrollTop = 0;
	var delta = 5;
	var minScrollToStartChanges = 30;
	var minScrollTopToChangeBg = 7;
	var mainResponsiveBreak = 992;
	var delayTime = 200;
	var animationSpeed = 500;
	/*=======================================================================================================================*/


	/*
		* ZOBRAZOVANI A SKRYVANI ROZJIZDECICH POLOZEK V MAIN MENU
		* Pokud je sirka okna vetsi jak 'mainResponsiveBreak' vysunovaci menu se bude vysunovat
		* Pokud je sirka mensi zustavalo tam to menu po hooveru zobrazene - timto tomu zamezim
	*/
	if($(window).width() > mainResponsiveBreak){
		$(".dropdown, .dropdown-active").hover(function() {
			$(this).find('.dropdown-menu').eq(0).stop(true, true).delay(delayTime).fadeIn(animationSpeed);
		}, function() {
		  	$(this).find('.dropdown-menu').eq(0).stop(true, true).delay(delayTime).fadeOut(animationSpeed);
		});
	}
	
	/*
		* ZOBRAZOVANI A SKRYVANI MENU PRI SCROLLU
		* Cast pro skryvani menu pri scrollu dolu
		* Pokud se provedl scroll zavolam fci hasScrolled kde budu testovat scroll dolu nebo nahoru a setuju tridu nav-up
	*/
	$(window).scroll(function(){
    	hasScrolled();
	});

	/*
  		* POMOCNA FUNKCE PRO ZOBRAZOVANI A SKRYVANI MENU PRI SCROLLU
		* @return: void
		* @param:
		*
		* Ulozim si velikost scrollu od topu, trida nav-up schovava menu, na konci fce ukladam aktual scroll pro priste (last)
		* Pridavam si class pro barvu pozadi
		* Otestuju velikost oproti predchozimu scrollu jestli je vetsi jak delta(5), pokud ne, prerusim fci
		* Pokud je velikost scrollu vetsi jak posledni scroll a scroll je vetsi jak vyska menu -> scrolloval dolu - pridam tridu
		* Elese if - odebiram classu pro pridani barvy pozadi - aby menu prekryvalo obsah
		* Else pokud je vyska okna + scroll mensi jak vyska dokumentu -> odeberu tridu nav-up a zobrazim menu
  */
	function hasScrolled() {
	    var scrollTop = $(this).scrollTop();
	    
	    if(Math.abs(lastScrollTop - scrollTop) <= delta)
	        return;

		if ($(window).height() > 600) {
			if (scrollTop > lastScrollTop && scrollTop > minScrollToStartChanges) {
				// Scroll Down
				$('.navbar').addClass('nav-up');
				$('.navbar').removeClass('navbar-bg');
			} else if (scrollTop < minScrollTopToChangeBg) {
				// Navbar is on his right place - upside
				$('.navbar').removeClass('navbar-bg');
				$('.navbar').removeClass('nav-up');
			} else {
				// Scroll Up
				if (scrollTop + $(window).height() < $(document).height() && scrollTop > minScrollToStartChanges) {
					$('.navbar').removeClass('nav-up');
					$('.navbar').addClass('navbar-bg');
				}
			}
		}

	    lastScrollTop = scrollTop;
	}
});
